export enum Permissions {
    ViewDashboards = 'view_dashboards',

    ViewUsers = 'view_users',
    ManageUsers = 'manage_users',

    ManageDisputes = 'manage_disputes',

    ManagePlatformSettings = 'manage_platform_settings',

    ManagePaymentProfiles = 'manage_payment_profiles',

    ManageUserBalance = 'manage_user_balance',

    ManageTeam = 'manage_team',

    ManageApi = 'manage_api',

    DepositInfo = 'deposit_info',

    ViewNotifications = 'view_notifications'
}
